import { apiFetch } from './client';

const BASE = '/labels';

/** List all labels (returns a bare array, not paged). */
export const list = ({ signal } = {}) => apiFetch(BASE, { signal });

/** Get a label by uuid. */
export const get = (uuid, { signal } = {}) =>
  apiFetch(`${BASE}/${encodeURIComponent(uuid)}`, { signal });

/** Create a label. */
export const create = (body, { signal } = {}) =>
  apiFetch(BASE, { method: 'POST', body: JSON.stringify(body), signal });

/** Partial-update a label. */
export const update = (uuid, body, { signal } = {}) =>
  apiFetch(`${BASE}/${encodeURIComponent(uuid)}`, { method: 'PATCH', body: JSON.stringify(body), signal });

/** Delete a label. */
export const remove = (uuid, { signal } = {}) =>
  apiFetch(`${BASE}/${encodeURIComponent(uuid)}`, { method: 'DELETE', signal });
